import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <div className="pt-24 min-h-screen" data-id="element-167">
      <About data-id="element-168" />
    </div>;
}